// @flow @format
import React from 'react';
import LoginFormContainer from '../../containers/LoginFormContainer';
import CogsIcon from '../../../../components/Icon/cogs';
import './Login.css';

const Login = () => {
	if (!navigator.webkitPersistentStorage) {
		return (
			<section
				style={{
					width: '90%',
					margin: '5% auto',
					textAlign: 'center',
					border: '1px solid var(--divider-color)',
					padding: 'calc(var(--baseline) * 4) 0',
				}}
			>

				<CogsIcon style={{fontSize: 'calc(var(--baseline) * 4)'}} />

				<h2>Navegador no soportado</h2>

				<p>
					Esta aplicación requiere Chrome versión 30 o superior.
				</p>
				<p>
					Puede obtenerlo en el siguiente vínculo:{' '}
					<a
						href="https://www.google.es/chrome/browser/desktop/"
						target="_blank"
						rel="noopener noreferrer"
					>
						{' '}Google Chrome
					</a>
				</p>

			</section>
		);
	}

	return (
		<div className="Login">
			<LoginFormContainer />
		</div>
	);
};

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login/pages/Login/Login.js